import {
  useMemo,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getManufacturers, resetManufacturers } from 'store/manufacturers/actions';
import {
  getManufacturers as getManufacturersSelector,
  getManufacturersLoadingState,
  getManufacturersUniqueOptions,
  getNameIdsMap,
} from 'store/manufacturers/selectors';
import useDebounce from 'library/hooks/use-debounce';
import { getLabelMap } from 'library/helpers/text';

const useManufacturerList = (skip = true, defaultSnapshot = {}, resetOnUnmount = true) => {
  const [query, onQueryChange] = useState('');
  const debouncedQuery = useDebounce(query, 300);
  const dispatch = useDispatch();
  const data = useSelector(getManufacturersSelector);
  const isLoading = useSelector(getManufacturersLoadingState);
  const { options } = useSelector(getManufacturersUniqueOptions);
  const nameToIdsMap = useSelector(getNameIdsMap);
  const labelMapSnapshot = useRef({});

  useEffect(() => {
    if (!skip) {
      dispatch(getManufacturers({ name: debouncedQuery }));
    } else if(skip && data.length) {
      if (data.length && resetOnUnmount) {
        // labelMapSnapshot.current = {};

        dispatch(resetManufacturers());
      }

      if (debouncedQuery) {
        onQueryChange('');
      }
    }
  }, [debouncedQuery, skip]);

  useEffect(() => {
    return () => {
      if(resetOnUnmount) {
        labelMapSnapshot.current = {};

        dispatch(resetManufacturers());
      }
    };
  }, []);

  return useMemo(() => {
    const labelMap = getLabelMap(data, {
      ...defaultSnapshot,
      ...labelMapSnapshot.current,
    });

    labelMapSnapshot.current = labelMap;

    return {
      data,
      isLoading,
      options,
      labelMap,
      onQueryChange,
      nameToIdsMap,
    };
  }, [data, defaultSnapshot]);
};

export default useManufacturerList;
